const GoogleIcon = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_582_6694)">
        <g clipPath="url(#clip1_582_6694)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.131 10.3349C19.131 9.69553 19.0725 9.08027 18.9638 8.49023H10.3047V11.9789H15.2527C15.0396 13.1062 14.3917 14.0612 13.4182 14.7009V16.9636H16.3895C18.1282 15.3934 19.131 13.0814 19.131 10.3349Z"
            fill="#4285F4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3021 19.1489C12.7845 19.1489 14.8656 18.3414 16.3869 16.9638L13.4156 14.7011C12.5925 15.2422 11.539 15.5621 10.3021 15.5621C7.9074 15.5621 5.88081 13.9758 5.15776 11.8438H2.08594V14.1806C3.59867 17.1281 6.70789 19.1489 10.3021 19.1489Z"
            fill="#34A853"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.15904 11.844C4.97515 11.3029 4.87075 10.7247 4.87075 10.1305C4.87075 9.53624 4.97515 8.95805 5.15904 8.41692V6.08008H2.08722C1.46467 7.29761 1.10938 8.67525 1.10938 10.1305C1.10938 11.5857 1.46467 12.9634 2.08722 14.1809L5.15904 11.844Z"
            fill="#FBBC05"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3021 4.69818C11.652 4.69818 12.864 5.15332 13.8169 6.04679L16.454 3.46002C14.8614 2.00518 12.7802 1.11133 10.3021 1.11133C6.70828 1.11133 3.59867 3.13252 2.08594 6.07965L5.15776 8.41649C5.88081 6.28487 7.90779 4.69818 10.3021 4.69818Z"
            fill="#EA4335"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_582_6694">
          <rect width={20} height={20} fill="white" />
        </clipPath>
        <clipPath id="clip1_582_6694">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GoogleIcon;
